import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zbwp6qqnd: FaireProductEntity = {
  token: "p_2zbwp6qqnd",
  type: "product",
  name: "Crystal Water Bottle",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/0340a42844355f296d207561342ccc84f197ab1100fe82d7cce33348a4f4a082.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1835c7f85f43df646281f19a410f724a57758ec1e6f1cfced4852f46e127c2c7.jpeg",
    "https://cdn.faire.com/fastly/161b52cd22c451a2da1b7c0a82364704eb9e8e94f1848eef05610c56d9306482.jpeg",
    "https://cdn.faire.com/fastly/fe086a58f6d56aae4ae27fb3c529509060e43c9ec170868c29a0a70d88443eb5.jpeg",
    "https://cdn.faire.com/fastly/796c472ffc67b3c6102f31987389a3e4417dec694c393b7683af47fe8631ead0.jpeg",
    "https://cdn.faire.com/fastly/2baf040e06cf94bc9dcb3c901274a10b4a4c390320354813162c59f7069fed82.jpeg",
    "https://cdn.faire.com/fastly/ea10690594be7fa0c65194eef8633142a4bb2775a0d31562cc3651658bf6c96e.jpeg",
    "https://cdn.faire.com/fastly/a89d446f94c997e9b6242f8aeec05d85cecee8bfd6d8c91c80d64a2d40368e4f.jpeg",
    "https://cdn.faire.com/fastly/7623a0c71fa8a4b4ae84d9b6dc6490561a01a7df28d0491bd02deaa9e215e3f8.jpeg",
    "https://cdn.faire.com/fastly/689dc2c5cc9e3c809bdea7ffcbca3413c3cb10c0aee78e17e6cf43182eb669a8.jpeg",
    "https://cdn.faire.com/fastly/864a65460b34921406c7858e06b3c548e8707aef9b8523d0e396b80ea84b9a2f.jpeg",
    "https://cdn.faire.com/fastly/8357ac1eaef40ffb115f8395eb753040beebbca2cb0c2d917d976be77f900d2c.jpeg",
    "https://cdn.faire.com/fastly/485d169332c03452bf392c431bb02517ece11953625ff1558af2afe44b9e9541.jpeg",
    "https://cdn.faire.com/fastly/58ae4cf5be4649e67953c0f9babaf2b1e128f0a5fd035ec908703603fdc29350.jpeg",
    "https://cdn.faire.com/fastly/3e3a15750b78edee70169122dcbd1bfa2b2610bba6583eaf50a3147391fee7aa.jpeg",
    "https://cdn.faire.com/fastly/be9f246bb9ec8be8567f99a06f66f7c84530518bb3328946083e63f31d1b3a1d.jpeg",
    "https://cdn.faire.com/fastly/5e0b12960b5e8530e8c70d8bafd1042bae9f177da2516d8ef22010b91c3699f0.jpeg",
    "https://cdn.faire.com/fastly/32ed6c25a93169b6587d5d74bbc22b80ebd899ee1b731fae853b99f345409983.jpeg",
    "https://cdn.faire.com/fastly/323d3807c345aedff29d7d35cfbd6314c7ae3841a8465f39a4edfe972cbd6137.jpeg",
    "https://cdn.faire.com/fastly/30126ae47bba67930ed754c75c2451cba2f4a935d02ccf741f50c6284abb789b.jpeg",
    "https://cdn.faire.com/fastly/e75a05aebc24185da90ce825e02feb2f61fdc2c8e4dec79bba6ddcb54f09fec5.jpeg",
    "https://cdn.faire.com/fastly/6508eee3ce0b52c513cfce9b2f9b26b4a37e4eda45bf0e258b95f6ee0217403e.jpeg",
    "https://cdn.faire.com/fastly/a65f1bf5c9a6535c64d85dd9db1ba4321de2ca55624eb5fc84ad8e1eef804081.jpeg",
  ],
  priceDollars: 21,
  description:
    "Enjoy the benefits of Crystal Healing with a reusable, non-toxic BPA free and eco-friendly glass design that provides pure tasting water. It features a separate container that screws on the bottom of the bottle with several carefully selected gemstone blends that you can add your own special crystal to or change out the entire set if you choose. The gems are sealed inside the to prevent contamination.\n\n * 15oz \n * Comes w/protective black sleeve ",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:44.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
